import React from "react";

import DefaultTable from "../components/table";
import DynamicSnackbar from "../components/dynamic_snackbar";
import LoadingBackdrop from "../components/loading_backdrop";
import issueStateUpdateRequest from "../components/panel_update_helper";

class AdminHistoryPanel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      dynamicSnackbar: {
        open: false,
        severity: null,
        message: null,
        url: null,
      },
      adminHistory: {
        headers: [],
        values: [],
      },
    };
  }

  render() {
    return (
      <div className="panel server-panel">
        <LoadingBackdrop open={this.state.loading} />
        <DynamicSnackbar
          open={this.state.dynamicSnackbar.open}
          severity={this.state.dynamicSnackbar.severity}
          message={this.state.dynamicSnackbar.message}
          url={this.state.dynamicSnackbar.url}
          handleClose={() => {
            this.setState({
              dynamicSnackbar: { ...this.state.dynamicSnackbar, open: false },
            });
          }}
        />
        <h1>Admin History</h1>
        <div className="panel-section">
          <DefaultTable
            tableKey={this.state.adminHistory.name}
            tableHeaders={this.state.adminHistory.headers}
            tableRows={this.state.adminHistory.values}
          />
        </div>
      </div>
    );
  }

  async componentDidMount() {
    await issueStateUpdateRequest(
      this,
      "/admin_history_panel/get_admin_history_info"
    );
  }
}

export default AdminHistoryPanel;
